import { z } from 'zod';
// Request and response schemas for the API layer
export const FindPersonsByCompanyIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.string().uuid(),
    }),
});
//# sourceMappingURL=find-persons-by-company-id.dto.js.map